module.exports = __webpack_public_path__ + "static/media/voteheart.b144a7e7.png";